import { Template } from '../../mocks/websiteTemplates';

export interface Collection {
  id: string;
  name: string;
  tagline: string;
  icon: string;
  gradient: string;
  accentColor: string;
  filterFn: (t: Template) => boolean;
}

export const COLLECTIONS: Collection[] = [
  {
    id: 'dark-mode',
    name: 'Dark Mode',
    tagline: 'Sleek. Moody. Unforgettable.',
    icon: 'ri-moon-fill',
    gradient: 'from-gray-900 via-slate-800 to-gray-900',
    accentColor: '#94a3b8',
    filterFn: (t) => t.tags.includes('Dark'),
  },
  {
    id: 'best-startups',
    name: 'Best for Startups',
    tagline: 'Launch fast, look great.',
    icon: 'ri-rocket-fill',
    gradient: 'from-violet-600 via-purple-600 to-cyan-600',
    accentColor: '#a78bfa',
    filterFn: (t) => t.category === 'SaaS & Tech' || (t.badge === 'Popular' && t.tags.includes('Modern')),
  },
  {
    id: 'minimalist',
    name: 'Minimalist',
    tagline: 'Less noise, more impact.',
    icon: 'ri-contrast-drop-2-fill',
    gradient: 'from-gray-500 via-zinc-500 to-gray-600',
    accentColor: '#e5e7eb',
    filterFn: (t) => t.tags.includes('Minimal'),
  },
  {
    id: 'bold-vibrant',
    name: 'Bold & Vibrant',
    tagline: 'Make a loud statement.',
    icon: 'ri-fire-fill',
    gradient: 'from-orange-500 via-red-500 to-rose-600',
    accentColor: '#fb923c',
    filterFn: (t) => t.tags.includes('Bold') || t.tags.includes('Colorful'),
  },
  {
    id: 'earthy-warm',
    name: 'Earthy & Warm',
    tagline: 'Cozy vibes, pro finish.',
    icon: 'ri-sun-fill',
    gradient: 'from-amber-500 via-orange-400 to-yellow-500',
    accentColor: '#fcd34d',
    filterFn: (t) => t.tags.includes('Warm'),
  },
  {
    id: 'elegant-luxury',
    name: 'Elegant & Luxury',
    tagline: 'Premium. Refined. Timeless.',
    icon: 'ri-vip-crown-fill',
    gradient: 'from-rose-600 via-pink-600 to-fuchsia-700',
    accentColor: '#f9a8d4',
    filterFn: (t) => t.tags.includes('Elegant'),
  },
  {
    id: 'corporate-pro',
    name: 'Corporate Pro',
    tagline: 'Authority you can feel.',
    icon: 'ri-briefcase-4-fill',
    gradient: 'from-slate-700 via-slate-800 to-slate-900',
    accentColor: '#cbd5e1',
    filterFn: (t) => t.tags.includes('Corporate') || t.category === 'Finance & Legal',
  },
  {
    id: 'new-arrivals',
    name: 'New Arrivals',
    tagline: 'Fresh off the press.',
    icon: 'ri-sparkling-fill',
    gradient: 'from-emerald-500 via-teal-500 to-cyan-600',
    accentColor: '#6ee7b7',
    filterFn: (t) => t.badge === 'New',
  },
];
